export const createSerialWriter = (write) => {
  let tail = Promise.resolve();

  return {
    enqueue(value) {
      const result = tail.catch(() => {}).then(() => write(value));
      tail = result;
      return result;
    },
    flush() {
      return tail;
    },
  };
};
